import { isUndefined } from 'lodash';

export const isDefined = value => !isUndefined(value);
